import { useContext } from "react";

import { CreateEntityResponse } from "../../../../common/api/common/CreateEntityResponse";
import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { CreateWatermarkRuleRequest } from "./CreateWatermarkRuleRequest";
import { DeleteWatermarkRuleRequest } from "./DeleteWatermarkRuleRequest";
import { GetWatermarkRuleListResponse } from "./GetWatermarkRuleListResponse";
import { UpdateWatermarkRuleRequest } from "./UpdateWatermarkRuleRequest";

export const useAdminWatermarkRuleApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const { httpGet, httpPost, httpPut, httpDelete } = useAuthorizedFetch();
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/watermark-rules/`;

    const getWatermarkRuleList = async (): Promise<GetWatermarkRuleListResponse> => {
        return httpGet<GetWatermarkRuleListResponse>(`${baseUrl}list`);
    };

    const createWatermarkRule = async (request: CreateWatermarkRuleRequest): Promise<CreateEntityResponse> => {
        return httpPost(`${baseUrl}create`, request);
    };

    const deleteWatermarkRule = async (request: DeleteWatermarkRuleRequest): Promise<void> => {
        return httpDelete(`${baseUrl}delete`, request);
    };

    const updateWatermarkRule = async (request: UpdateWatermarkRuleRequest): Promise<void> => {
        return httpPut(`${baseUrl}update`, request);
    };

    return {
        getWatermarkRuleList,
        createWatermarkRule,
        deleteWatermarkRule,
        updateWatermarkRule
    };
};
